import React, { useState } from 'react';

const initialState = {
  envio: {
    data: "Indefinido"
  }
}

const setEnvio = (stateEnvio, setState, envio, data) => {
    setState({envio, data})
}

export const EnvioContext = React.createContext({
  stateEnvio: initialState,
  actionsEnvio: {
    setEnvio: () => {}
  }
});


export const EnvioContextProvider = props => {
    const [stateEnvio, _setState] = useState(initialState)

    const setState = (_state) => {
        const newState = { ...stateEnvio, ..._state }
        _setState(newState)
    }

    const actionsEnvio = {
      setEnvio: setEnvio.bind(null, stateEnvio, setState)
    }

    return (
        <EnvioContextProvider.Provider value={{ stateEnvio, actionsEnvio }} >
            {props.children}
        </EnvioContextProvider.Provider>
    );
}